import React from "react";
import Select from "react-select";
import { sortObjectsByAlphabet } from "../../utils";
import { getDeviceTypeFetchConfigCommand } from "./systemSettingsService";

function FetchDeviceTypeField({ deviceTypes = [], value, onChange }) {

    const handleChange = async (selectedOption) => {
        let selectedDeviceType = null;
        let fetchCommand = '';
        if (selectedOption && selectedOption.value > 0) {
            selectedDeviceType = deviceTypes.find(type => type.id === Number(selectedOption.value));
            fetchCommand = await getDeviceTypeFetchConfigCommand(selectedDeviceType.id);
        }
        onChange(selectedDeviceType, fetchCommand);
    }

    const deviceTypesCopy = sortObjectsByAlphabet(deviceTypes, 'name');

    const options = deviceTypesCopy
        ? deviceTypesCopy.map(deviceType => ({
            value: deviceType.id,
            label: deviceType.name
        }))
        : [];

    return (
        <div className="oct_settings-field mb-3">
            <label className="oct_settings-label">Device Type</label>
            <Select
                id="deviceType"
                className="oct_selectsearch-v2"
                classNamePrefix="oct-selectsearchsub-v2"
                value={value ? options.find(option => option.value === value.id) || null : null}
                onChange={handleChange}
                options={options}
                isSearchable
                placeholder="Choose"
                noOptionsMessage={() => "No device types available"}
            />
        </div>
    );
}

export default FetchDeviceTypeField;
